// @ts-ignore
import html2pdf from 'html2pdf.js'

export const exportPdf = (fileName: any, ref: any, callback: any, opt?:any) => {

    var worker = html2pdf().set({
        margin: 10,
        pagebreak: {before: '.page-break', after: ['#after1', '#after2'], avoid: 'img'},
        filename: fileName,
        image: {type: 'jpeg', quality: 0.98},
        html2canvas: {scale: 3},
        jsPDF: {
            width: ref?.current?.offsetWidth,
            unit: 'mm',
            format: 'a2',
            orientation: 'landscape',
            putOnlyUsedFonts: true,
            floatPrecision: 16,
            ...opt
        },
    }).from(ref.current).save().then((res: any) => {
            callback && callback()
        },
        (err: any) => {
            callback && callback()
        });

    // const doc = new jsPDF(
    //     {
    //         format: "a4",
    //         unit: "px",
    //         precision: 100,
    //     }
    // );
    // console.log('refcurrent', ref.current)
    // console.log('doc', doc)
    // doc.html(ref.current, {
    //     autoPaging: 'text',
    //     margin: [16, 12],
    //     html2canvas: {
    //         scale: 0.35,
    //         windowWidth: 1200
    //     },
    //     windowWidth: 1200,
    //     width: 1200,
    //
    //     async callback(doc) {
    //         doc.save(`${fileName}.pdf`);
    //     }
    // }).then(res => {
    //     callback && callback()
    // });

};
